import { Damage } from '../damage/damage.class';
import { GT_PARTS } from '../third-party-info/third-party-info-estimation.class';
export class SmartphotoReport {
    damages = [];
    uuid;
    main;
    type;
    constructor(report, mismatchedPartIds = []) {
        this.uuid = report.uuid;
        this.main = report.is_main_report;
        this.type = report.report_type;
        const damages = report.damages.map(({ mainDetection, otherDetection }) => new Damage(mainDetection, otherDetection, false, mismatchedPartIds.includes(GT_PARTS[mainDetection.part.id])));
        damages.forEach((damage) => {
            damage.setExists(true);
            this.add(damage);
        });
    }
    addDamages(damages) {
        this.damages = [];
        damages.forEach((damage) => {
            damage.setExists(true);
            this.add(damage);
        });
    }
    add(damage) {
        const deleted = this.type === 'deleted';
        if (deleted) {
            if (!damage.exists) {
                return;
            }
            // eslint-disable-next-line no-param-reassign
            damage.deleted = true;
        }
        else {
            const origin = this.main ? 'claim' : 'other';
            [damage, ...damage.others].forEach((dmg) => {
                // eslint-disable-next-line no-param-reassign
                dmg.origin = origin;
            });
        }
        this.damages.push(damage);
    }
    getTotalCost() {
        return this.damages.reduce((acc, damage) => acc + (damage.estimation.total ?? 0), 0);
    }
    export() {
        return { damages: this.damages.map(({ uuid }) => ({ uuid })), is_main_report: this.main, report_type: this.type, uuid: this.uuid };
    }
}
